import { Trigger } from '@radix-ui/react-collapsible'
import type { ReactNode } from 'react'
import React from 'react'

import { procsea } from '../../../themes'
import { CollapsibleContent, CollapsibleRoot } from './Collapsible.styles'

export interface CollapsibleProps {
  'data-e2e'?: string
  children?: ReactNode
  duration?: number
  fluid?: boolean
  forceMount?: true
  open?: boolean
  setOpen: React.Dispatch<boolean>
}

const Collapsible = ({
  'data-e2e': dataE2e,
  children,
  duration = procsea.transitions.duration,
  fluid,
  forceMount,
  open,
  setOpen,
}: CollapsibleProps) => (
  <CollapsibleRoot data-fluid={fluid} data-e2e={dataE2e} open={open} onOpenChange={setOpen}>
    <CollapsibleContent duration={duration} forceMount={forceMount}>
      {children}
    </CollapsibleContent>
  </CollapsibleRoot>
)

const CollapsibleTrigger = Trigger

export { Collapsible, CollapsibleContent, CollapsibleRoot, CollapsibleTrigger }
